"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;
var _utils = require("../../../../utils");
/**
 * @private
*/
const color = function () {
  let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  code = code.toLowerCase().replace(/\s/, '-');
  switch (code) {
    case 'prcp':
      return '#2ef000';
    case 'snow':
      return '#004fff';
    case 'hsnd':
      return '#e402a4';
    case 'maxt':
      return '#ff4b00';
    case 'mint':
      return '#8700ff';
    case 'himn':
      return '#eef500';
    case 'lomx':
      return '#37b9f8';
    default:
      return '#000000';
  }
};
/**
 * @private
*/
const config = exports.config = {
  data: {
    request: {
      endpoint: 'records'
    },
    properties: {
      id: 'id',
      timestamp: 'report.timestamp'
    }
  },
  style: {
    marker: data => {
      const type = (0, _utils.get)(data, 'report.type');
      return {
        className: 'marker-record',
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: color(type)
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [14, 14]
      };
    }
  },
  animation: {
    enabled: true
  }
};
var _default = exports.default = config;